var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"elevation-btn mx-auto mt-3 f-btn",attrs:{"color":_vm.btnColor,"rounded":"","large":"","min-width":"300","height":"43"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }